import React from "react"
import { useTranslation } from "react-i18next"

import FormElement from "components/Form/FormElement"

export const AdditionalInformationForm = ({
	partner,
	setUpdatedPartner,
	errors,
	setErrors,
	isEdit,
	isViewMode,
	editCallback,
	refresh,
	showLocalErrors,
	setShowLocalErrors,
	isAdminEditing,
}) => {
	const [formFields, setFormFields] = React.useState({})
	const defaultFormEvents = React.useMemo(
		() => ({
			ready: true,
			// when form is in edition mode, by default the editable is set at false
			// when the form is not in edition mode, it means creation mode, the form should be editable
			editable: !isEdit,
			viewMode: isViewMode || false,
			// eslint-disable-next-line react-hooks/exhaustive-deps
		}),
		[isEdit]
	)
	const [formEvents, setFormEvents] = React.useState(defaultFormEvents)

	React.useEffect(() => {
		setFormEvents((prev) => ({ ...prev, editable: isEdit }))
	}, [isEdit])

	React.useEffect(() => {
		// When partner reloaded (after await fetchData()), set data in formFields
		// setFormFields(partner)
		if (partner || !isEdit) setFormFields(partner)
	}, [partner, isEdit])

	React.useEffect(
		() => {
			// When we create a new partner, we have to pass data to parent directly.
			setUpdatedPartner((prevFormFields) => ({
				...prevFormFields,
				site_web: formFields.site_web,
			}))
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[formFields]
	)

	const { t } = useTranslation()

	const handleInputChange = React.useCallback((event) => {
		const target = event.target
		const value = target.type === "checkbox" ? target.checked : target.value
		const name = target.name
		setFormFields((s) => ({
			...s,
			[name]: value,
		}))
	}, [])

	const handleValidation = React.useCallback((name, errs) => {
		setErrors((s) => {
			const cleanErrors = [...s.filter((e) => e.origin !== name)]
			return [...cleanErrors, ...errs]
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleSubmit = async (event) => {
		event.preventDefault()
		// Validate inputs
		const formReady = !(errors.length > 0)

		if (!formReady) {
			setShowLocalErrors(true)
		} else {
			// hide error
			setShowLocalErrors(false)
			// prevent form to be submitted again
			setFormEvents((s) => ({
				...s,
				ready: false,
			}))

			const updatedPartner = {
				...formFields,
				site_web: formFields.site_web,
			}

			await editCallback(updatedPartner)

			setFormEvents((s) => ({
				...s,
				ready: true,
				editable: false,
			}))
		}
	}

	return (
		<form id="additional" className="py-16 px-4 scroll-mt-10">
			<h2 className="c-h2 font-semibold mb-5 uppercase">
				{t("store.additional_infos", { ns: "partner" })}
			</h2>
			<div>
				<div className="lg:w-1/2 w-full py-5">
					{/* website */}
					<FormElement
						value={formFields.site_web}
						name="site_web"
						type="text"
						label={t("store.website", { ns: "partner" })}
						required={false}
						readonly={!formEvents.editable}
						showErrors={showLocalErrors}
						onValidate={handleValidation}
						onChange={handleInputChange}
					/>
				</div>
			</div>
		</form>
	)
}
